import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Replace } from '../../stores/branches/actions';

// Service
import BranchService from '../../services/branchService';

const initialFilters = {
    pageNumber:1,
    pageSize: 100,
    onlyData: true
};
const useBranches = () => {
    const { branches, branchesForDisplay } = useSelector(state => state.branches_data);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const FindBranches = () => {
            setLoading(true);
            BranchService
                .Search(initialFilters)
                .then(res => {
                    const branchesData = res.values;
                    dispatch(Replace(branchesData, branchesData.reduce((acum, value) => ({
                    ...acum,
                    [value.code]: value.name
                }), {})))
                })
                .finally(() => setLoading(false));
        }
        if(!branches || branches.length === 0 || !branchesForDisplay)
            FindBranches();
    }, [branches, branchesForDisplay, dispatch])

    return {
        branches,
        branchesForDisplay,
        loading
    }
}

export default useBranches;